module.exports = __webpack_public_path__ + "img/calendar-day-fill.e7e1929d.svg";